import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ContentsVolume from './ContentsVolume';
import ContentsThumbnail from '../ContentsMng/ContentsThumbnail';
import Confirm from '../Dialog/Confirm';
import { utilHelper } from '../../helpers';
import { alertActions } from '../../modules/alert';
import "react-datepicker/dist/react-datepicker.css";


class ContentsItem extends Component {
    constructor(props) {
        super(props);
        let years = []; for (let i = moment(props.coBeginDate).format('YYYY'); i <= moment(props.coEndDate).format('YYYY'); i++) years = years.concat(i + "");
        let months = []; for (let i = 1; i <= 12; i++) months = months.concat(utilHelper.pad(i));

        this.state = {
            content: {
                ...props.content,
                startTime: props.content.startTime ? props.content.startTime : "00:00:00",
                endTime: props.content.endTime ? props.content.endTime : "23:59:59",
                contentVolume: props.content.contentVolume ? props.content.contentVolume : 0.5,
                showTime: props.content.showTime ? props.content.showTime : 180000,
            },

            // 스케줄 사용 여부 (Y/N)
            scheduleType: (props.content.enabledDate === 0 && props.content.enabledTime === 0 && props.content.enabledDow === 0) ? "N" : "Y",

            years: years,
            months: months,
            startHour: "00",
            startMin: "00",
            startSec: "00",
            endHour: "23",
            endMin: "59",
            endSec: "59",
            showMin: "03",
            showSec: "00",
            dows: ["0", "0", "0", "0", "0", "0", "0"],
            open: false,
        };
    }

    setContentsItemState = (itemChange) => {
        let years = []; for (let i = moment(this.props.coBeginDate).format('YYYY'); i <= moment(this.props.coEndDate).format('YYYY'); i++) years = years.concat(i);

        const startTimeArr = this.props.content.startTime.split(":");
        const startHour = startTimeArr[0] ? startTimeArr[0] : "00";
        const startMin = startTimeArr[1] ? startTimeArr[1] : "00";
        const startSec = startTimeArr[2] ? startTimeArr[2] : "00";

        const endTimeArr = this.props.content.endTime.split(":");
        const endHour = endTimeArr[0] ? endTimeArr[0] : "23";
        const endMin = endTimeArr[1] ? endTimeArr[1] : "59";
        const endSec = endTimeArr[2] ? endTimeArr[2] : "59";

        const dows = this.props.content.dowMask ? this.props.content.dowMask.split("") : this.state.dows;
        const showTime = this.props.content.showTime ? this.props.content.showTime / 1000 : 180;

        this.setState({
            content: {
                ...this.props.content,
                startTime: this.props.content.startTime ? this.props.content.startTime : "00:00:00",
                endTime: this.props.content.endTime ? this.props.content.endTime : "23:59:59",
                contentVolume: this.props.content.contentVolume ? this.props.content.contentVolume : 0.5,
                showTime: this.props.content.showTime ? this.props.content.showTime : 180000,
            },
            scheduleType: itemChange !== "itemChange" ? this.state.scheduleType : ((this.props.content.enabledDate === 0 && this.props.content.enabledTime === 0 && this.props.content.enabledDow === 0) ? "N" : "Y"),
            years: years,
            startHour: startHour,
            startMin: startMin,
            startSec: startSec,
            endHour: endHour,
            endMin: endMin,
            endSec: endSec,
            showMin: utilHelper.pad(parseInt(showTime / 60)),
            showSec: utilHelper.pad(parseInt(showTime % 60)),
            dows: dows,
        });

    };

    componentDidMount() {
        this.setContentsItemState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.content !== this.props.content) {
            this.setContentsItemState(prevProps.content.boardID !== this.props.content.boardID ? "itemChange" : "");
        }
    }

    // scheduleType 변경
    handleScheduleTypeTypeChange = (e) => {
        this.setState({
            content: {
                ...this.state.content,
                enabledDate: e.target.value === "N" ? 0 : this.state.content.enabledDate,
                enabledTime: e.target.value === "N" ? 0 : this.state.content.enabledTime,
                enabledDow: e.target.value === "N" ? 0 : this.state.content.enabledDow,
            },
            [e.target.name]: e.target.value
        }, () => { this.props.setContentListMod(this.state.content, this.props.index); });
    };

    // enabledDate, enabledTime, enabledDow 변경
    handleEnableTypeChange = (e) => {
        this.setState({
            content: {
                ...this.state.content,
                [e.target.name]: this.state.content[e.target.name] === 0 ? 1 : 0,
            }
        }, () => { this.props.setContentListMod(this.state.content, this.props.index); });
    };

    // 날짜 기반 - 일자변경
    handleStartDateChange = (date) => {
        const startDate = this.props.coBeginDate > moment(date).format('YYYY-MM-DD hh:mm:ss') ? this.props.coBeginDate : moment(date).format('YYYY-MM-DD hh:mm:ss');
        let content = this.props.content;
        content.startDate = startDate;

        if (moment(this.props.coBeginDate).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')) {
            this.props.errorAlerts("계약시작일(" + moment(this.props.coBeginDate).format('YYYY-MM-DD') + ") 이전입니다.");
        }

        this.setState({
            content: {
                ...this.state.content,
                startDate: startDate,
            }
        });

        this.props.setContentListMod(content, this.props.index);
    };

    handleEndDateChange = (date) => {
        const endDate = this.props.coEndDate < moment(date).format('YYYY-MM-DD hh:mm:ss') ? this.props.coEndDate : moment(date).format('YYYY-MM-DD hh:mm:ss');
        let content = this.props.content;
        content.endDate = endDate;

        if (moment(this.props.coEndDate).format('YYYY-MM-DD') < moment(date).format('YYYY-MM-DD')) {
            this.props.errorAlerts("계약종료일(" + moment(this.props.coEndDate).format('YYYY-MM-DD') + ") 이후입니다.");
        }

        this.setState({
            content: {
                ...this.state.content,
                endDate: endDate,
            }
        });

        this.props.setContentListMod(content, this.props.index);
    };

    // 시간 기반 - 시간변경
    handleStartTimeChange = (e) => {
        const startHour = e.target.name === "startHour" ? utilHelper.pad(e.target.value, 2) : this.state.startHour;
        const startMin = e.target.name === "startMin" ? utilHelper.pad(e.target.value, 2) : this.state.startMin;
        const startSec = e.target.name === "startSec" ? utilHelper.pad(e.target.value, 2) : this.state.startSec;
        const startTime = startHour + ":" + startMin + ":" + startSec;

        if (utilHelper.isNumber(e.target.value)) {
            if ((startHour >= 0 && startHour < 24) && (startMin >= 0 && startMin < 60) && (startSec >= 0 && startSec < 60)) {
                let content = this.props.content;
                content.startTime = startTime;

                this.setState({
                    content: {
                        ...this.state.content,
                        startTime: startTime
                    },
                    startHour: startHour,
                    startMin: startMin,
                    startSec: startSec,
                });

                this.props.setContentListMod(content, this.props.index);
            }
            else {
                this.props.errorAlerts("시간 범위를 확인하세요.");
            }
        }
        else {
            this.props.errorAlerts("숫자만 입력하세요.");
        }
    };

    handleEndTimeChange = (e) => {
        const endHour = e.target.name === "endHour" ? utilHelper.pad(e.target.value, 2) : this.state.endHour;
        const endMin = e.target.name === "endMin" ? utilHelper.pad(e.target.value, 2) : this.state.endMin;
        const endSec = e.target.name === "endSec" ? utilHelper.pad(e.target.value, 2) : this.state.endSec;
        const endTime = endHour + ":" + endMin + ":" + endSec;

        if (utilHelper.isNumber(e.target.value)) {
            if ((endHour >= 0 && endHour < 24) && (endMin >= 0 && endMin < 60) && (endSec >= 0 && endSec < 60)) {
                let content = this.props.content;
                content.endTime = endTime;

                this.setState({
                    content: {
                        ...this.state.content,
                        endTime: endTime
                    },
                    endHour: endHour,
                    endMin: endMin,
                    endSec: endSec,
                });

                this.props.setContentListMod(content, this.props.index);
            }
            else {
                this.props.errorAlerts("시간 범위를 확인하세요.");
            }
        }
        else {
            this.props.errorAlerts("숫자만 입력하세요.");
        }
    };

    // 요일기반 - 요일변경
    handleDowMaskChange = (index) => {
        if (this.state.content.enabledDow === 1) {
            const dows = this.state.dows;
            if (dows[index] === "0") dows[index] = "1";
            else dows[index] = "0";

            let dowMask = "";
            dows.map(dow => dowMask += dow);

            let content = this.props.content;
            content.dowMask = dowMask;

            this.setState({
                content: {
                    ...this.state.content,
                    dowMask: dowMask
                },
                dows: dows,
            });

            this.props.setContentListMod(content, this.props.index);
        }
    };

    // 이미지 - 노출시간(showTime)변경
    handleShowTimeChange = (e) => {
        const showMin = e.target.name === "showMin" ? utilHelper.pad(e.target.value, 2) : this.state.showMin;
        const showSec = e.target.name === "showSec" ? utilHelper.pad(e.target.value, 2) : this.state.showSec;
        const showTime = (parseInt(showMin) * 60 + parseInt(showSec)) * 1000;

        if (utilHelper.isNumber(e.target.value)) {
            if ((showMin >= 0 && showMin < 100) && (showSec >= 0 && showSec < 60)) {
                let content = this.props.content;
                content.showTime = showTime;

                this.setState({
                    content: {
                        ...this.state.content,
                        showTime: showTime
                    },
                    showMin: showMin,
                    showSec: showSec
                });

                this.props.setContentListMod(content, this.props.index);
            }
            else {
                this.props.errorAlerts("시간 범위를 확인하세요.");
            }
        }
        else {
            this.props.errorAlerts("숫자만 입력하세요.");
        }
    };


    // 동영상볼륨 설정
    handleContentVolumeChange = (volume) => {
        let content = this.props.content;
        content.contentVolume = volume;

        this.setState({
            content: {
                ...this.state.content,
                contentVolume: volume
            }
        });

        this.props.setContentListMod(content, this.props.index);
    };

    // 컨텐츠 삭제
    handleDelButton = () => {
        this.setState({
            open: true,
        });
    };

    setContentListDel = () => {
        this.props.setContentListDel(this.props.index);
        this.handleClose();
    };

    handleClose = () => {
        this.setState({
            open: false,
        });
    };


    render() {
        const { index, content } = this.props;

        return (
            <>
                <div className="s-drag-item">
                    <span className="s-no">{index + 1}</span>
                    <div className="s-img-box">
                        <span className={`s-flag ${content.contentKindCode === "CK002" ? "s-blue" : "s-orange"}`}>{index + 1}. {content.contentKindCode === "CK002" ? "이미지" : "동영상"}</span>
                        <ContentsThumbnail contentKindCode={content.contentKindCode} boardID={content.boardID ? content.boardID : 0} boardFileID={content.contentKindCode === "CK002" ? content.boardfileID : content.thumbnailfileID} />
                    </div>
                    <strong className="s-sub-tit">{content.title}</strong>
                    <div className="s-flex-box">
                        <select className="s-select" name="scheduleType" value={this.state.scheduleType} onChange={this.handleScheduleTypeTypeChange} >
                            <option value="N">스케줄 미사용</option>
                            <option value="Y">스케줄 사용</option>
                        </select>
                    </div>
                    <div className="s-flex-box">
                        <label className="" style={{ marginBottom: "auto" }}>
                            <input className="margin-r10" type="checkbox" name="enabledDate" checked={content.enabledDate === 1} onChange={this.handleEnableTypeChange} disabled={this.state.scheduleType !== "Y"} />
                            <span>기간 설정</span>
                        </label>
                    </div>
                    <div className="s-flex-box">
                        <div className="s-flex-auto">
                            <DatePicker className="input-box w100per padding-l10"
                                renderCustomHeader={({
                                    date,
                                    changeYear,
                                    changeMonth,
                                }) => (
                                    <div>
                                        <select className="opbState-mng-mod-years" value={moment(date).format('YYYY')} onChange={({ target: { value } }) => changeYear(value)}>
                                            {this.state.years.map((year, i) => {
                                                return <option key={i} value={year}>{year}</option>;
                                            })}
                                        </select>
                                        <select className="opbState-mng-mod-months" value={moment(date).format('MM')} onChange={({ target: { value } }) => changeMonth(value - 1)}>
                                            {this.state.months.map((month, i) => {
                                                return <option key={i} value={month}>{month}</option>;
                                            })}
                                        </select>
                                    </div>
                                )}
                                selected={new Date(moment(content.startDate).format())}
                                selectsStart
                                startDate={new Date(moment(content.startDate).format())}
                                endDate={new Date(moment(content.endDate).format())}
                                maxDate={new Date(moment(content.endDate).format())}
                                dateFormat="yyyy-MM-dd"
                                disabledKeyboardNavigation
                                onChange={this.handleStartDateChange}
                                disabled={content.enabledDate !== 1}
                            />
                        </div>
                        <div className="s-flex-auto">&#126;</div>
                        <div className="s-flex-auto">
                            <DatePicker className="input-box w100per padding-l10"
                                renderCustomHeader={({
                                    date,
                                    changeYear,
                                    changeMonth,
                                }) => (
                                    <div>
                                        <select className="opbState-mng-mod-years" value={moment(date).format('YYYY')} onChange={({ target: { value } }) => changeYear(value)}>
                                            {this.state.years.map((year, i) => {
                                                return <option key={i} value={year}>{year}</option>;
                                            })}
                                        </select>
                                        <select className="opbState-mng-mod-months" value={moment(date).format('MM')} onChange={({ target: { value } }) => changeMonth(value - 1)}>
                                            {this.state.months.map((month, i) => {
                                                return <option key={i} value={month}>{month}</option>;
                                            })}
                                        </select>
                                    </div>
                                )}
                                selected={new Date(moment(content.endDate).format())}
                                selectsEnd
                                startDate={new Date(moment(content.startDate).format())}
                                endDate={new Date(moment(content.endDate).format())}
                                minDate={new Date(moment(content.startDate).format())}
                                dateFormat="yyyy-MM-dd"
                                disabledKeyboardNavigation
                                onChange={this.handleEndDateChange}
                                disabled={content.enabledDate !== 1}
                            />
                        </div>
                    </div>
                    <div className="s-flex-box">
                        <label className="" style={{ marginBottom: "auto" }}>
                            <input className="margin-r10" type="checkbox" name="enabledTime" checked={content.enabledTime === 1} onChange={this.handleEnableTypeChange} disabled={this.state.scheduleType !== "Y"} />
                            <span>시간 설정</span>
                        </label>
                    </div>
                    <div className="s-flex-box">
                        <div className="s-flex-auto">
                            <input className="input-box w100per text-align-center" name="startHour" value={this.state.startHour} onChange={this.handleStartTimeChange} disabled={content.enabledTime !== 1} />
                        </div>
                        <div className="s-flex-none" style={{ padding: "0px 2px" }}>시</div>
                        <div className="s-flex-auto">
                            <input className="input-box w100per text-align-center" name="startMin" value={this.state.startMin} onChange={this.handleStartTimeChange} disabled={content.enabledTime !== 1} />
                        </div>
                        <div className="s-flex-none" style={{ padding: "0px 2px" }}>분</div>
                        <div className="s-flex-auto">
                            <input className="input-box w100per text-align-center" name="startSec" value={this.state.startSec} onChange={this.handleStartTimeChange} disabled={content.enabledTime !== 1} />
                        </div>
                        <div className="s-flex-none" style={{ padding: "0px 2px" }}>초</div>
                        <div className="s-flex-none s-mini-tit">&#126;</div>
                    </div>
                    <div className="s-flex-box">
                        <div className="s-flex-auto">
                            <input className="input-box w100per text-align-center" name="endHour" value={this.state.endHour} onChange={this.handleEndTimeChange} disabled={content.enabledTime !== 1} />
                        </div>
                        <div className="s-flex-none" style={{ padding: "0px 2px" }}>시</div>
                        <div className="s-flex-auto">
                            <input className="input-box w100per text-align-center" name="endMin" value={this.state.endMin} onChange={this.handleEndTimeChange} disabled={content.enabledTime !== 1} />
                        </div>
                        <div className="s-flex-none" style={{ padding: "0px 2px" }}>분</div>
                        <div className="s-flex-auto">
                            <input className="input-box w100per text-align-center" name="endSec" value={this.state.endSec} onChange={this.handleEndTimeChange} disabled={content.enabledTime !== 1} />
                        </div>
                        <div className="s-flex-none" style={{ padding: "0px 2px" }}>초</div>
                        <div className="s-flex-none s-mini-tit"></div>
                    </div>
                    <div className="s-flex-box">
                        <label className="" style={{ marginBottom: "auto" }}>
                            <input className="margin-r10" type="checkbox" name="enabledDow" checked={content.enabledDow === 1} onChange={this.handleEnableTypeChange} disabled={this.state.scheduleType !== "Y"} />
                            <span>요일 설정</span>
                        </label>
                    </div>
                    <div className="s-flex-box">
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[0] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(0)}>일</div>
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[1] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(1)}>월</div>
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[2] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(2)}>화</div>
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[3] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(3)}>수</div>
                    </div>
                    <div className="s-flex-box">
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[4] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(4)}>목</div>
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[5] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(5)}>금</div>
                        <div className={`s-flex-none s-mini-tit-dow ${this.state.dows[6] === "1" ? "active" : ""}`} onClick={() => this.handleDowMaskChange(6)}>토</div>
                    </div>
                    {content.contentKindCode === "CK002" &&
                        <div className="s-flex-box" style={{ visibility: content.contentKindCode === "CK002" ? "visible" : "hidden" }}>
                            <div className="s-flex-none s-mini-tit">노출시간</div>
                            <div className="s-flex-auto">
                                <input className="input-box w100per text-align-center" name="showMin" value={this.state.showMin} onChange={this.handleShowTimeChange} />
                            </div>
                            <div className="s-flex-none s-unit-text">분</div>
                            <div className="s-flex-auto">
                                <input className="input-box w100per text-align-center" name="showSec" value={this.state.showSec} onChange={this.handleShowTimeChange} />
                            </div>
                            <div className="s-flex-none s-unit-text">초</div>
                        </div>
                    }
                    {content.contentKindCode !== "CK002" &&
                        <div className="s-flex-box">
                            <div className="s-flex-none s-mini-tit">설정</div>
                            <ContentsVolume contentsTypeCode={this.props.contentsTypeCode} contentVolume={this.state.content.contentVolume} handleContentVolumeChange={this.handleContentVolumeChange} />
                        </div>
                    }
                    <div className="s-box-close" onClick={this.handleDelButton}>삭제</div>
                    {this.state.open === true &&
                        <Confirm message={`삭제하시겠습니까?\n삭제하신 영상은 [추가]버튼을 클릭하면\n불러올 수 있습니다.`} kind="del" handleFormSubmit={this.setContentListDel} handleClose={this.handleClose} />
                    }
                </div>
            </>
        );
    }
}


function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsItem);